import React from 'react'
import { useLocation } from 'react-router-dom'
import AppBottomNav from 'businessTraveller/components/app-bottom-nav/AppBottomNav'
import {
  getAppBottomNavActiveTab,
  hasAppBottomNavSolidBackground,
  shouldShowAppBottomNav,
} from 'businessTraveller/utils/appBottomNavRouteUtils'
import { useAppSelector } from 'hooks/reduxHooks'
import { selectLoggedIn } from 'selectors/accountSelectors'

/**
 * Mounts the white label app's bottom tab bar on the pages listed in `MOBILE_APP_BOTTOM_NAV_ROUTES`
 */
function AppBottomNavRoutes() {
  const { pathname } = useLocation()
  const isLoggedIn = useAppSelector(selectLoggedIn)

  if (!isLoggedIn || !shouldShowAppBottomNav(pathname)) return null

  return <AppBottomNav
    activeTab={getAppBottomNavActiveTab(pathname)}
    background={hasAppBottomNavSolidBackground(pathname) ? 'solid' : 'transparent'}
  />
}

export default AppBottomNavRoutes
